import React, { Component } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {Text} from "@chakra-ui/react";

/*
const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";
*/

const divStyle = {
    width: "80%",

    height: '100%'
    //border: '5px solid black'
};

const columnDefs = [
    { headerName: "Batch Number", field: "batchNbr", sortable: true, filter: true, resizable: true, minWidth: 100},
    { headerName: "Batch Date", field: "batchDate", sortable: true, filter: true, resizable: true, minWidth: 100},  
    { headerName: "Ranch", field: "harvestLot.ranchName", sortable: true, filter: true, resizable: true, minWidth: 100},
    { headerName: "Block ID", field: "harvestLot.blockId", sortable: true, filter: true, resizable: true, minWidth: 100},
    { headerName: "Harvest Date", field: "harvestLot.harvestDate", sortable: true, filter: true, resizable: true, minWidth: 100},
    { headerName: "Qty", field: "qty", sortable: true, filter: true, resizable: true, minWidth: 25},

];

export default class DetailLotTable extends Component {
    constructor(props) {
        super(props);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
    }





    onSelectionChanged() {
        console.log("Changing selected row")
        var selectedNodes = this.gridApi.getSelectedNodes();
        var rowData = selectedNodes[0].data;
        console.info(rowData);
    }



    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit(params)
    };

    render() {

        return (
            <div className="ag-theme-balham" style={divStyle}>
                <Text margin={0} fontSize={'24px'} color={'white'}>Lots</Text>
                {(this.props.selectedItemRow) &&
                <AgGridReact
                    rowSelection="single"
                    enableRangeSelection={false}
                    // pagination={true}
                    columnDefs={columnDefs}
                    rowData={this.props.selectedItemRow.lotQtys}
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    onSelectionChanged={this.onSelectionChanged}
                    gridOptions={this.gridOptions}
                    domLayout="autoHeight"
                    suppressHorizontalScroll={true}
                />
                }
            </div>
        );
    }
}